var _path, _path2, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0497 19.7268C28.6588 19.7268 35.6379 17.2084 35.6379 14.1018C35.6379 10.9952 28.6588 8.47681 20.0497 8.47681C11.4405 8.47681 4.46143 10.9952 4.46143 14.1018C4.46143 17.2084 11.4405 19.7268 20.0497 19.7268Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75586 14.1018V26.5151C4.75586 27.9869 11.5532 29.175 20.05 29.175C28.5467 29.175 35.3441 27.9869 35.3441 26.5151V14.1018",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 8.99948,
    y2: -1,
    transform: "matrix(-0.0220117 0.999758 -0.999797 -0.0201286 11.6265 19.1625)",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 8.99948,
    y2: -1,
    transform: "matrix(-0.0220117 0.999758 -0.999797 -0.0201286 19.4614 20.1771)",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 8.99647,
    y2: -1,
    transform: "matrix(-0.0655359 0.99785 -0.998201 -0.0599481 28.3389 19.1709)",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.68975e95eeff35145964c6a726172e16.svg";
export { ForwardRef as ReactComponent };